import React from 'react';
import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/time-entry', label: 'Time Entry', countKey: 'timeEntry' },
  { to: '/projects', label: 'Projects', countKey: 'projects' },
  { to: '/reports', label: 'Reports', countKey: 'reports' },
  { to: '/settings', label: 'Settings', countKey: 'settings' },
];

const iconProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

function MoonIcon() {
  return (
    <svg {...iconProps}>
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  );
}

function SunIcon() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  );
}

export default function TopBar({ darkMode, setDarkMode, onLogout, loggedInUser, counts }) {
  return (
    <header className="flex flex-wrap items-stretch gap-x-6 bg-surface border-b border-line px-8">
      <div className="flex items-center text-[13.5px] font-bold tracking-tight py-4">
        Time Creative
      </div>

      <nav aria-label="Glavna navigacija" className="flex flex-wrap items-stretch">
        {NAV_ITEMS.map(({ to, label, countKey }) => {
          const count = counts ? counts[countKey] : undefined;
          const hasCount = count !== undefined && count !== null;
          return (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                'flex items-center gap-2 text-[13px] px-3.5 border-b-2 ' +
                (isActive
                  ? 'text-ink font-semibold border-accent'
                  : 'text-muted border-transparent hover:text-ink')
              }
            >
              {label}
              {hasCount && (
                <span className="text-[11px] font-semibold text-accent bg-accent-soft rounded-full px-1.5 py-0.5 tabular">
                  {count}
                </span>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="ml-auto flex flex-wrap items-center gap-3 py-2">
        <button
          type="button"
          onClick={() => setDarkMode(!darkMode)}
          aria-label={darkMode ? 'Switch to light theme' : 'Switch to dark theme'}
          className="flex items-center justify-center w-11 h-11 rounded-tc-sm border border-line bg-surface text-ink"
        >
          {darkMode ? <SunIcon /> : <MoonIcon />}
        </button>
        <span className="text-[12.5px] text-muted">{loggedInUser}</span>
        <button
          type="button"
          onClick={onLogout}
          className="text-[12.5px] rounded-tc-sm border border-line px-3.5 min-h-[44px]"
        >
          Log out
        </button>
      </div>
    </header>
  );
}
